module.exports = __webpack_public_path__ + "static/img/10.0d30fb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/10.png
// module id = ivNV
// module chunks = 0